/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import './daksh.css';
import { ALL_ROUTES, COMMON, DAKSH_SCREEN } from '../../global/Constants';
import { CROP_GROUP, DakshModuleType, DakshSaleType, DakshStatus } from '../../global/Enum';
import { OTP_VALIDATION_RIGHT, OTP_VALIDATION_WRONG } from '../../global/Icons';
import Select from 'react-select';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import DataProvider from '../../providers/DataProvider';
import Utilities from '../../global/Utilities';
import DakshHeader from './components/DakshHeader';
import ViewQuantity from './components/ViewQuantity';
import $ from 'jquery';
import ApiServices from '../../providers/ApiServices';
import Loader from '../common/loader/Loader';
import { toast } from 'react-toastify';
import Footer from '../common/Footer';
import SyncLoader from '../common/loader/SyncLoader';

const otpTimer = 60;

class DakshPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            retailers: [],
            selectedRetailer: null,
            moduleType: DakshModuleType.SALE,
            saleStatus: 0,
            planStatus: 0,

            saleData: null,
            // saleData: {
            //     isValidate: false,
            //     status: 1,
            //     total: 400,
            //     total_seedworks: 200,
            //     total_competitor: 200,
            //     seedworks: [
            //         { id: "1", crop_id: 1, crop_name: "Cotton", hybrid_id: 1, hybrid_name: "US 380", quantity: 100 },
            //         { id: "2", crop_id: 2, crop_name: "Cotton", hybrid_id: 2, hybrid_name: "US 380", quantity: 100 },
            //     ],
            //     competitors: [
            //         { id: "1", crop_id: 1, crop_name: "Cotton", hybrid_id: 1, hybrid_name: "US 380", quantity: 100 },
            //         { id: "2", crop_id: 2, crop_name: "Cotton", hybrid_id: 2, hybrid_name: "US 380", quantity: 100 },
            //     ],
            // },

            planData: null,

            digit1: "",
            digit2: "",
            digit3: "",
            digit4: "",
            otpMatch: false,
            time: {},
            seconds: otpTimer,

        }
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    async componentDidMount() {
        if (Utilities.checkLogin()) {
            await DataProvider.getInstance().fetchMasterData();
            document.getElementById("continue").disabled = true;
            this.getRetailers();

        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }



    getRetailers = () => {
        const cropGroups = DataProvider.getInstance().getCropGroups();
        let cropGroup = cropGroups[0];
        let is_vc = 1;
        if (cropGroup?.crop_group_id === CROP_GROUP.FIELD_CROPS) {
            is_vc = 0;
        } else {
            is_vc = 1;
        }

        const retailers = DataProvider.getInstance().getRetailers();
        if (retailers) {
            const retailerData = retailers.filter(item => {
                return (item.is_vc === is_vc);
            });
            Utilities.LogPrint("Retailer", retailerData);

            let retailerDataArray = [];
            retailerData.forEach(element => {
                let obj = {
                    value: element.retailer_id,
                    label: element.retailer_shop_name + " - " + element.phone,
                    retailer_name: element.retailer_name,
                    phone: element.phone,
                    state_id: element.state_id
                }
                retailerDataArray.push(obj);
            });

            const retailer = Utilities.getRetailer();
            Utilities.LogPrint("Local Storage Retailer", retailer);

            this.setState({
                retailers: retailerDataArray,
                selectedRetailer: retailer
            }, () => {
                if (retailer !== null) {
                    this.getDakshDataByRetailerId(retailer.value);
                }
            });
        }
    }

    getDakshDataByRetailerId = (retailerId) => {
        if (Utilities.isNetworkConnected()) {
            let request = JSON.stringify({
                retailer_id: retailerId
            })
            this.setState({ isLoading: true });
            try {
                ApiServices.getDakshDataByRetailerId(request)
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            const data = response.data;
                            if (data !== null) {

                                let saleStatus = this.setSaleStatus(data.saleData);
                                let planStatus = this.setStatus(data.planData);
                                //Utilities.LogPrint("Plan Status", planStatus);

                                this.setState({
                                    saleData: data.saleData,
                                    planData: data.planData,
                                    saleStatus: saleStatus,
                                    planStatus: planStatus
                                })
                            }
                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false, errorMsg: error });
            }

        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    setSaleStatus = (data) => {
        let status = DakshStatus.COMPLETED;
        if (data.is_validated) {
            status = DakshStatus.COMPLETED;
        } else if (this.checkVegCrops() && data?.total === 0) {
            status = DakshStatus.TO_START;
        } else if (data?.total_competitor === 0) {
            status = DakshStatus.TO_START;
        } else {
            status = DakshStatus.PENDING;
        }
        return status;
    }

    setStatus = (data) => {
        let status = DakshStatus.COMPLETED;
        if (data.is_validated) {
            status = DakshStatus.COMPLETED;
        } else if (data.total === 0) {
            status = DakshStatus.TO_START;
        } else {
            status = DakshStatus.PENDING;
        }
        return status;
    }

    handleModule = (type) => {
        //const { planData, selectedRetailer } = this.state;

        switch (type) {
            case DakshModuleType.SALE:
                this.setState({ moduleType: DakshModuleType.SALE });
                break;

            case DakshModuleType.PLAN:
                this.setState({ moduleType: DakshModuleType.PLAN });

                // For First Time Plan 
                // if (planData.total === 0) {
                //     this.props.history.push({
                //         pathname: ALL_ROUTES.PLAN_DETAILS_ROUTE,
                //         state: { saleType: DakshSaleType.SEEDWORKS_SALE, planData: planData }
                //     });
                // } else {
                //     this.setState({ saleType: DakshModuleType.PLAN });
                // }
                break;
            default:
                break;
        }
    }

    handleChange = selectedRetailer => {
        Utilities.LogPrint("Selected Retailer", selectedRetailer);
        Utilities.setRetailer(selectedRetailer);
        this.setState({
            selectedRetailer
        }, () => {
            this.getDakshDataByRetailerId(selectedRetailer.value);
        })
    }

    saleHandler = (type) => {
        const { saleStatus, saleData } = this.state;
        saleData.saleStatus = saleStatus;

        switch (type) {
            case DakshModuleType.SALE:
                //this.props.history.push(ALL_ROUTES.SALE_DETAILS_ROUTE);

                this.props.history.push({
                    pathname: ALL_ROUTES.SALE_DETAILS_ROUTE,
                    state: { saleType: DakshSaleType.SEEDWORKS_SALE, saleData: saleData }
                });
                break;
            case DakshModuleType.PLAN:
                //this.props.history.push(ALL_ROUTES.SALE_DETAILS_ROUTE);

                this.props.history.push({
                    pathname: ALL_ROUTES.SALE_DETAILS_ROUTE,
                    state: { saleType: DakshSaleType.COMPETITOR_SALE, saleData: saleData }
                });
                break;
            default:
                break;
        }
    }

    planHandler = (type) => {
        const { planStatus, planData } = this.state;
        planData.planStatus = planStatus;

        switch (type) {
            case 1:
                //this.props.history.push(ALL_ROUTES.SALE_DETAILS_ROUTE);
                this.props.history.push({
                    pathname: ALL_ROUTES.PLAN_DETAILS_ROUTE,
                    state: { saleType: DakshSaleType.SEEDWORKS_SALE, planData: planData }
                });
                break;
            case 2:
                //this.props.history.push(ALL_ROUTES.SALE_DETAILS_ROUTE);
                this.props.history.push({
                    pathname: ALL_ROUTES.PLAN_DETAILS_ROUTE,
                    state: { saleType: DakshSaleType.COMPETITOR_SALE, planData: planData }
                });
                break;
            default:
                break;
        }
    }

    startTimer() {
        if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
            Utilities.LogPrint("timer Main", this.timer);
        }
        let timeLeftVar = Utilities.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        if (seconds >= 0) {
            this.setState({
                time: Utilities.secondsToTime(seconds),
                seconds: seconds,
            });
        }
        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
        }
    }

    generateOTP = () => {
        //$('#otpButton').trigger('click');
        const { moduleType, saleData, planData, selectedRetailer } = this.state;
        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }

        let dakshId = 0;
        if (moduleType === DakshModuleType.SALE) {
            dakshId = saleData.daksh_id
        } else {
            dakshId = planData.daksh_id
        }

        var request = JSON.stringify({
            retailer_id: selectedRetailer.value,
            daksh_id: dakshId
        });
        this.setState({ isLoading: true });
        try {
            ApiServices.getOTPCodeInDaksh(request)
                .then(response => {
                    this.setState({ isLoading: false });
                    Utilities.LogPrint("sentRetailerOtp: ---->", response);
                    if (response.success) {
                        toast.info(response.message);
                        this.startTimer();
                        $('#otpButton').trigger('click');
                        //const data = response.data;

                    } else {
                        toast.info(response.message);
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {

                    Utilities.LogPrint("sentRetailerOtp", error);
                });
        } catch (error) {

            Utilities.LogPrint("sentRetailerOtp", error);
        }
    }

    handleResendOTP = (e) => {
        this.timer = 0;
        this.setState({
            digit1: "",
            digit2: "",
            digit3: "",
            digit4: "",
            seconds: otpTimer
        }, () => {
            //this.startTimer();
            this.generateOTP();
        });
    }

    verifyOtp = () => {
        // $('#otpSuccess').trigger('click');

        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }

        const { moduleType, saleData, planData, selectedRetailer, digit1, digit2, digit3, digit4 } = this.state;
        const otpNumber = digit1 + digit2 + digit3 + digit4;

        let dakshId = 0;
        if (moduleType === DakshModuleType.SALE) {
            dakshId = saleData.daksh_id
        } else {
            dakshId = planData.daksh_id
        }

        var request = JSON.stringify({
            daksh_id: dakshId,
            otp: otpNumber
        });
        this.setState({ isLoading: false });
        try {
            ApiServices.validateOTP(request)
                .then(response => {
                    Utilities.LogPrint("verifyRetailerOtp: ---->", response);
                    this.setState({ isLoading: false });
                    clearInterval(this.timer);
                    if (response.success) {
                        $('#otpSuccess').trigger('click');
                        this.getDakshDataByRetailerId(selectedRetailer.value);
                        //const data = response.data;
                    } else {
                        //toast.info(response.message);
                        Utilities.LogPrint("Status", response.message);
                        $('#otpFailed').trigger('click');
                    }
                }).catch(error => {
                    Utilities.LogPrint("verifyRetailerOtp", error);
                });
        } catch (error) {
            Utilities.LogPrint("verifyRetailerOtp", error);
        }
    }

    resendOTP = () => {
        $('#otpFailed').trigger('click');
    }

    handleOTPChange(e, ref) {
        const { digit1, digit2, digit3, digit4 } = this.state;
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });

        if (digit1 === "" || digit2 === "" || digit3 === "" || digit4 !== "") {
            document.getElementById("continue").disabled = true;
        } else {
            document.getElementById("continue").disabled = false;
        }

        if (ref !== this.myInp1) {
            ref.focus();
        }
    }


    checkVegCrops = () => {
        const cropGroups = DataProvider.getInstance().getCropGroups();
        Utilities.LogPrint("CropGroups", cropGroups);
        if (cropGroups.length > 0) {
            Utilities.LogPrint("CropGroups In Menu", cropGroups?.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS));
            return cropGroups?.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS);
        } else {
            return false;
        }
    }

    // checkSaleValidate() {
    //     const { saleStatus, saleData } = this.state;
    //     if (this.checkVegCrops() && saleData?.total > 0) {
    //         Utilities.LogPrint("VC Crop Group", "True");
    //         return true;
    //     } else {
    //         Utilities.LogPrint("VC Crop Group", "False");
    //         return saleStatus === DakshStatus.PENDING && saleData?.total_competitor > 0;
    //     }
    // }

    isValidate() {
        const { moduleType, selectedRetailer, saleStatus, planStatus } = this.state;
        if (moduleType === DakshModuleType.SALE) {
            return selectedRetailer !== null && saleStatus === DakshStatus.PENDING;
        } else {
            return selectedRetailer !== null && planStatus === DakshStatus.PENDING;
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, isSyncLoading, tableName, moduleType, retailers, selectedRetailer, saleStatus, planStatus, saleData, planData } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <Footer />
                <div className="container pt-35 pb-3 daksh">
                    <DakshHeader />

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="row">
                                <div className="col-12">
                                    <Select className="mb-3 max-w-360"
                                        value={selectedRetailer}
                                        onChange={this.handleChange}
                                        options={retailers}
                                        placeholder="Select the Retailer"
                                        isClearable={false}
                                    />

                                    {/* <select
                                        className="form-control mb-3"
                                        onChange={this.handleChange}>
                                        <option value="">Select the Retailer</option>
                                        <option value="">Amjad Husaain</option>
                                        <option value="">Ashish</option>
                                    </select> */}
                                </div>
                            </div>


                            {/* Sale and Plan Buttons */}
                            {selectedRetailer !== null ?
                                <div className="row mt-0 mt-md-4">
                                    <div className="col-6 col-md-6">
                                        <button
                                            className={moduleType === DakshModuleType.SALE ? "btn btn-border active-btn w-100" : "btn btn-border w-100"}
                                            onClick={() => this.handleModule(DakshModuleType.SALE)}>
                                            {DAKSH_SCREEN.SALE}
                                            <i className={
                                                saleStatus === DakshStatus.TO_START ? "customic ic-sale-red" :
                                                    saleStatus === DakshStatus.PENDING ? "customic ic-sale-yellow" :
                                                        saleStatus === DakshStatus.COMPLETED ? "customic ic-sale-green" : "d-none"
                                            }></i>
                                            {/* <i className="customic ic-sale-green"></i>
                                            <i className="customic ic-sale-yellow"></i>
                                            <i className="customic ic-sale-red"></i> */}
                                        </button>
                                    </div>

                                    <div className="col-6 col-md-6">
                                        <button
                                            className={moduleType === DakshModuleType.PLAN ? "btn btn-border active-btn w-100" : "btn btn-border w-100"}
                                            onClick={() => this.handleModule(DakshModuleType.PLAN)}>
                                            {DAKSH_SCREEN.PLAN}
                                            <i className={
                                                planStatus === DakshStatus.TO_START ? "customic ic-sale-red" :
                                                    planStatus === DakshStatus.PENDING ? "customic ic-sale-yellow" :
                                                        planStatus === DakshStatus.COMPLETED ? "customic ic-sale-green" : "d-none"
                                            }></i>
                                            {/* <i className="customic ic-sale-green"></i> */}
                                            {/*<i className="customic ic-sale-yellow"></i>
                                            <i className="customic ic-sale-red"></i>*/}
                                        </button>
                                    </div>
                                </div> : null
                            }
                        </div>

                        {selectedRetailer !== null && moduleType === DakshModuleType.SALE ?
                            <div className="col-12 mt-2 mt-md-4 sale-table">
                                <h5 className="font">{DAKSH_SCREEN.SALE}</h5>
                                <ViewQuantity
                                    data={saleData}
                                    clickHandler={this.saleHandler} />
                            </div> : null
                        }

                        {selectedRetailer !== null && moduleType === DakshModuleType.PLAN ?
                            <div className="col-12 mt-2 mt-md-4 sale-table">
                                <h5 className="font">{DAKSH_SCREEN.PLAN}</h5>
                                <ViewQuantity
                                    data={planData}
                                    clickHandler={this.planHandler} />
                            </div> : null
                        }

                        <div className={this.isValidate() ? "" : "d-none"}>
                            <div className="col-12 mt-2 mt-md-4 mb-5">
                                <button className="btn btn-primary align-items-center justify-content-center w-182"
                                    type="button"
                                    data-toggle="modal"
                                    //data-target="#otpModal"
                                    onClick={this.generateOTP}>
                                    {DAKSH_SCREEN.VALIDATE}
                                </button>

                                {/* This Must be hidden */}
                                <button id="otpButton" type="button" data-toggle="modal" data-target="#otpModal"
                                    className="d-none">placeholder</button>
                                <button id="otpSuccess" type="button" data-toggle="modal" data-target="#otpValidationRight"
                                    className="d-none">placeholder</button>
                                <button id="otpFailed" type="button" data-toggle="modal" data-target="#otpValidationWrong"
                                    className="d-none">placeholder</button>
                            </div>
                        </div>

                    </div>
                </div>
                {this.showOtpVerificationPopup()}
                {this.showOptVerifySuccessPopup()}
                {this.showOptVerifyFailedPopup()}
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
            </div>

        )
    }

    showOtpVerificationPopup = () => {
        const { digit1, digit2, digit3, digit4, time, seconds } = this.state;
        return (
            <div className="modal fade bottom-drawer" id="otpModal" role="dialog" aria-modal="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body daksh-otp-modal">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <div className="col-12">
                                <h5>We have sent you One Time Password to your number</h5>
                                <form action="">
                                    <p className="text-red">Please Enter OTP</p>
                                    <span>{time.s} sec</span>
                                    <div className="form-group otp-input mt-md-3">
                                        <input type="number" className="form-control" placeholder="-" name="digit1" maxLength="1" ref={(ip) => this.myInp1 = ip} value={digit1} onChange={(e) => { this.handleOTPChange(e, this.myInp2) }} />
                                        <input type="number" className="form-control" placeholder="-" name="digit2" maxLength="1" ref={(ip) => this.myInp2 = ip} value={digit2} onChange={(e) => { this.handleOTPChange(e, this.myInp3) }} />
                                        <input type="number" className="form-control" placeholder="-" name="digit3" maxLength="1" ref={(ip) => this.myInp3 = ip} value={digit3} onChange={(e) => { this.handleOTPChange(e, this.myInp4) }} />
                                        <input type="number" className="form-control" placeholder="-" name="digit4" maxLength="1" ref={(ip) => this.myInp4 = ip} value={digit4} onChange={(e) => { this.handleOTPChange(e, this.myInp1) }} />
                                    </div>

                                    <div className="row">
                                        <div className="col-6">
                                            <button className="btn btn-secondary w-100 mb-2 mt-md-3"
                                                type="button"
                                                data-dismiss="modal"
                                                onClick={this.handleResendOTP}
                                                disabled={seconds > 0 ? true : false}
                                            >
                                                {COMMON.RESEND_OTP}
                                            </button>
                                        </div>
                                        <div className="col-6">
                                            <button className="btn btn-primary w-100 mb-2 mt-md-3"
                                                id="continue"
                                                type="button"
                                                onClick={this.verifyOtp}
                                                data-dismiss="modal">
                                                {COMMON.SUBMIT}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    showOptVerifySuccessPopup = () => {
        return (
            <div className="modal fade bottom-drawer" id="otpValidationRight" role="dialog" aria-modal="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body otp-validation">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <div className="col-12 text-center">
                                <img className="py-4" src={OTP_VALIDATION_RIGHT} alt="" />
                                <h4>Validation success</h4>
                                <p>Thank you for Retailer validation.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    showOptVerifyFailedPopup = () => {
        return (
            <div className="modal fade bottom-drawer" id="otpValidationWrong" role="dialog" aria-modal="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body otp-validation">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <div className="col-12 text-center">
                                <img className="py-4" src={OTP_VALIDATION_WRONG} alt="" />
                                <h4>Validation Failed</h4>
                                <p>There was an error. Please enter correct OTP</p>

                                <button
                                    className="btn btn-secondary w-182 mb-2 mt-md-3"
                                    data-dismiss="modal"
                                    onClick={this.handleResendOTP}>Resend OTP
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(DakshPage);